import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import LoginPage from "../pages/login";
import ChatPage from "../pages/chat";
import ProtectedRoute from "./protected";
import { AuthProvider } from "../utils/authentication";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Voice from "../pages/voice";
import OptionsPage from "../pages/option";
import Realtime from "../pages/realtime";
import ProfilePage from "../pages/profile";

const AppRoutes = () => {
    return (
        <Router>
            <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            >
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<LoginPage />} />
                        <Route
                            path="/chat"
                            element={
                                <ProtectedRoute>
                                    <ChatPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/voice"
                            element={
                                <ProtectedRoute>
                                    <Voice />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/options"
                            element={
                                <ProtectedRoute>
                                    <OptionsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/realtime"
                            element={
                                <ProtectedRoute>
                                    <Realtime />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </AuthProvider>
            </GoogleOAuthProvider>
        </Router>
    );
};

export default AppRoutes;
